export default "__VITE_ASSET__DiykpP9E__"